import { addGlobalThemeStyles } from '@vaadin/vaadin-themable-mixin/register-styles.js';
export var addLumoGlobalStyles = function addLumoGlobalStyles(id) {
  for (var _len = arguments.length, styles = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    styles[_key - 1] = arguments[_key];
  }

  addGlobalThemeStyles("lumo-".concat(id), styles);
};